var pageModule;
var pageModuleIsLoadComplete = false;
var waitReceiveMessage=[];
var waitChildrenReceiveMessage=[];
/**
 * 所有module集合
 * 格式：
 * {
 * pageid:"",
 * routerId:"",
 * pageModule:{},
 * pageModuleIsLoadComplete:false,
 * waitReceiveMessage:[],
 * waitChildrenReceiveMessage:[]
 * }
 */
var pageModuleList=[];
/**
 * 页面组件注册
 * @param {*} object 
 */
function registerModule(object,pageid,routerId){
    if(!routerId){
        //代表是主页面
        this.pageModule = object;
    }
    if(!pageid&&!routerId){
        this.pageModuleList=[{
            pageid:object.id,
            routerId,
            pageModule:object,
            pageModuleIsLoadComplete:false,
            waitReceiveMessage:[],
            waitChildrenReceiveMessage:[]
        }];
    }
    var hasExists = this.pageModuleList.filter(item=>item.routerId==routerId)
    //根据路由查找不重复的
    if(hasExists.length==0){
        this.pageModuleList.push({
            pageid,
            routerId,
            pageModule:object,
            pageModuleIsLoadComplete:false,
            waitReceiveMessage:[],
            waitChildrenReceiveMessage:[]
        })
    }
}
/**
 * 卸载注册的组件
 * @param {*} routerId 
 */
function unRegisterModule(routerId){
    for (let index = 0; index < this.pageModuleList.length; index++) {
        const element = this.pageModuleList[index];
        if(element.routerId==routerId){
            this.pageModuleList.splice(index,1);
        }
    }
}
/**
 * 页面加载完成的事件、组件按需加载完成的事件
 */
function pageLoadCompleteAfter(routerId){
    var module_list = this.pageModuleList.filter(item=>item.routerId==routerId);
    if(module_list.length>0){
        var moduleObject = module_list[0];
        moduleObject.pageModuleIsLoadComplete = true;
        //做消息延时100,虽然组件加载完成了，但是组件内的代码运行需要时间，这部分无法保证是否加载完成，并且延时100毫秒可能也未必做到组件加载完成再发送消息，
        //所以取适中的方法就是延时一定时间，然后组件内再自行做处理
        let that = this;
        setTimeout(() => {
            moduleObject.waitReceiveMessage.forEach(item=>{
                that.callModuleReceiveHandle(item,routerId)
            });
            moduleObject.waitReceiveMessage = [];
            moduleObject.waitChildrenReceiveMessage.forEach(item=>{
                that.sendChildren(item,routerId)
            });
            moduleObject.waitChildrenReceiveMessage = [];
        }, 100);
    }
}
/**
 * 页面组件按需加载之前的事件
 */
function pageModuleLoadCompleteBefore(routerId){
    var module_list = this.pageModuleList.filter(item=>item.routerId==routerId);
    if(module_list.length>0){
        var moduleObject = module_list[0];
        moduleObject.pageModuleIsLoadComplete = false;
    }
}

/**
 * 给子组件发送消息
 * @param {
 *  type:"自己定义的",
 *  message:{实际的消息对象},
 *  module:{packageid:"",containerIndex:""} or [{packageid:"",containerIndex:""}]   组件的packageid 和 containerIndex
 * } object 
 */
function sendChildren(object,routerId){
    if(!object||(object&&!object.module)){
        return;
    }
    this.pageModuleList&&this.pageModuleList.forEach(pageObject=>{
        if(!routerId||pageObject.routerId==routerId){
            if(!pageObject.pageModuleIsLoadComplete){
                //加入等待加载队列
                pageObject.waitChildrenReceiveMessage.push(object);
                return;
            }
            var module = object.module;
            if(module instanceof Object){
                //对象
                module = [module]
            }
            for (let index = 0; index < module.length; index++) {
                const element = module[index];
                this.sendChildrenInner(null,element,object,pageObject)
            }
        }
    });
}
/**
 * 内部递归查找发送方法
 * @param {*} moduleObject {packageid:"",containerIndex:""}
 * @param {*} object 
 */
function sendChildrenInner(children,moduleObject,object,pageObject){
    if(pageObject.pageModule){
        var layout = children|| pageObject.pageModule.page.layout.children;
        layout&&layout.forEach(item=>{
            if(item.packageid==moduleObject.packageid){
                //是当前组件,看是否有containerIndex，如果不为-1且不为空则去查找相等的containerIndex
                item.children&&item.children.forEach(sitem=>{
                    if(sitem.containerIndex==moduleObject.containerIndex||!moduleObject.containerIndex||moduleObject.containerIndex=="-1"||moduleObject.containerIndex==0){
                        //匹配上了，发送消息
                        pageObject.pageModule.page.componentsMap.forEach(ssitem=>{
                            if(sitem.packageid==ssitem.packageid){
                                //回调发送消息
                                ssitem.idmBroadcastMessage&&ssitem.idmBroadcastMessage(object)
                            }
                        })
                    }
                })
            }else if(item.children&&item.children.length>0){
                this.sendChildrenInner(item.children,moduleObject,object,pageObject);
            }
        })
    }
}

/**
 * 广播消息
 * @param {
 *  type:"自己定义的",
 *  message:{实际的消息对象},
 *  rangeModule:"为空发送给全部，指定属性中的key则会取属性的值（组件的packageid），不取子表的",
 *  className:"指定的组件类型，比如只给待办组件发送，然后再去过滤上面的值"
 *  globalSend:如果为true则全站发送消息，注意全站rangeModule是无效的，只有className才有效，默认为false
 * } object 
 * @param {String} routerId 路由ID，如果为空则是给所有已打开的页面发送消息，如果不为空则是只给指定的路由ID所在的页面发送消息
 */
function send(object,routerId){
    this.callModuleReceiveHandle({
        //当前页面直接发送的
        type:"direct",
        object
    },routerId) 
}
/**
 * 桥接消息发送的方法
 * @param {*} object 
 * @param {String} routerId 路由ID，如果为空则是给所有已打开的页面发送消息，如果不为空则是只给指定的路由ID所在的页面发送消息
 */
function bridgeSend(object,routerId){
    //这里给组件传消息的时候把isAcross设置为true加上
    this.callModuleReceiveHandle({
        //跨页面发送的
        type:"across",
        object
    },routerId)
}
/**
 * 执行组件的接收消息公共方法
 * @param {
 *  type:"direct 或者 across",
 *  object：发送消息的对象数据
 * } object 
 * @param {String} routerId 路由ID，如果为空则是给所有已打开的页面发送消息，如果不为空则是只给指定的路由ID所在的页面发送消息
 */
function callModuleReceiveHandle(object,routerId){
    if(!routerId){
        routerId="";
    }
    //routerId 为空就执行全部的组件，不为空则过滤routerId
    this.pageModuleList&&this.pageModuleList.forEach(moduleObject=>{
        if(routerId===""||moduleObject.routerId==routerId){
            if(!moduleObject.pageModuleIsLoadComplete){
                //加入等待加载队列
                moduleObject.waitReceiveMessage.push(object);
                return;
            }
            //循环对比页面的schema的json数据进行执行发送回调
            if(moduleObject.pageModule){
                var isAcross = object.type!="direct";
                moduleObject.pageModule.page.componentsMap.forEach(item=>{
                    if(item.className==object.object.className||!object.object.className){
                        var rangeModule = object.object.rangeModule;
                        //为空或者范围包含都进行发送
                        if(!rangeModule||(rangeModule&&rangeModule.length==0)||((rangeModule instanceof Array)&&_.includes(rangeModule,item.packageid))){
                            //回调发送消息
                            item.idmBroadcastMessage&&item.idmBroadcastMessage({
                                ...object.object,
                                isAcross:isAcross
                            })
                            /**
                             * 弹窗执行的后续逻辑
                             */
                            if(object.object.type=="linkageOpenDialog"&&object.object.message.layerOption){
                                //openUrl
                                const layerOption = object.object.message.layerOption,moduleId=item.packageid;
                                if(layerOption.openUrl){
                                    if(typeof layerOption.openUrl === "string"){
                                        //延迟，有特效
                                        setTimeout(() => {
                                            document.querySelector("#"+moduleId+" iframe").src = layerOption.openUrl;
                                        }, 600);
                                    }else if(layerOption.openUrl instanceof Array){
                                        //是数组
                                        setTimeout(() => {
                                            layerOption.openUrl.forEach(layerObject=>{
                                                document.querySelector("#"+moduleId+" iframe[name='"+layerObject.name+"']").src = layerObject.url;
                                            })
                                        }, 600);
                                    }
                                }
                                layerOption.success&&layerOption.success(item);
                            }
                        }
                    }
                })
            }
        }
    })
    if(!object.object.globalSend){
        return true;
    }
    //如果object.type=="direct" 则需要往父级发送
    if(object.type=="direct"){
        //直连情况下还是要继续往上找一级
        this.findParentModuleHandle(_.cloneDeep(object),routerId)
    }
    //获取子级iframe了(如果是往上找的就不要再往下了)
    if(object.type!="parent"){
        if(window.frames.length>0){
            for (let index = 0; index < window.frames.length; index++) {
                try {
                    const iframe = window.frames[index];
                    if(iframe.IDM){
                        iframe.IDM.broadcast&&iframe.IDM.broadcast.bridgeSend(_.cloneDeep(object.object),routerId);
                    }
                } catch (error) {
                    console.log("跨页面发送消息失败。",error)
                }
            }
        }
    }else{
        //继续往上找
        this.findParentModuleHandle(_.cloneDeep(object),routerId)
    }
}
/**
 * 向父级页面直接调用callModuleReceiveHandle消息函数
 * @param {*} object 
 */
function findParentModuleHandle(object,routerId){
    object.type = "parent";
    //判断是否有父级
    if(parent.location.href!=location.href){
        //代表着父级页面存在
        parent.IDM&&parent.IDM.broadcast.callModuleReceiveHandle(object,routerId)
    }
}
/**
 * 获取组件的返回值
 * @param [
 *  {
 *  moduleId:packageid,
 *  moduleName:asName
 *  }
 * ] pageModuleList 
 * @param {*} groupKey 
 * @param {String} routerId 路由ID，如果为空则会获取所有页面匹配的值，如果不为空只会获取当前路由匹配的页面
 * 
 * return {resultData,errorData}
 */
function getModuleContextValue(pageModuleList,groupKey,routerId){
    if(!(pageModuleList instanceof Array)&&pageModuleList)
    {
        pageModuleList = [pageModuleList];
    }
    var rangeModule = [];
    pageModuleList&&pageModuleList.forEach(item=>{
        rangeModule.push(IDM.type(item)=="string"?item:item.moduleId);
    })
    var resultData = [],errorData=[];
    //routerId 为空就执行全部的组件，不为空则过滤routerId
    this.pageModuleList&&this.pageModuleList.forEach(pageObject=>{
        if(!routerId||pageObject.routerId==routerId){
            if(pageObject.pageModule){
                pageObject.pageModule.page.componentsMap.forEach(item=>{
                    //查找指定的key名称（formGroupKey）
                    var formGroupKey = item.props&&item.props.compositeAttr?item.props.compositeAttr.formGroupKey:"";
                    if(_.includes(rangeModule,item.packageid)||(formGroupKey==groupKey&&formGroupKey!='')){
                        if(item.idmGetContextValue){
                            let rtnObject = item.idmGetContextValue();
                            if(!rtnObject){
                                return;
                            }
                            if(rtnObject.type=="success"){
                                //成功
                                resultData.push(rtnObject)
                            }else if(rtnObject.type=="error"){
                                //失败
                                errorData.push(rtnObject)
                            }
                        }
                    }
                })
            }
        }
    });
    return {resultData,errorData};
}
/**
 * 返回组件范围数据
 * @param [
 *  {
 *  moduleId:packageid,
 *  moduleName:asName
 *  }
 * ] pageModuleList 
 * @param {*} groupKey 
 * 
 * @param {String} routerId 路由ID，如果为空则会获取所有页面匹配的值，如果不为空只会获取当前路由匹配的页面
 * 
 * return ["packageid",...]
 */
function getRangeModule(pageModuleList,groupKey,routerId){
    if(!(pageModuleList instanceof Array)&&pageModuleList)
    {
        pageModuleList = [pageModuleList];
    }
    var rangeModule = [];
    pageModuleList&&pageModuleList.forEach(item=>{
        if(item&&item.moduleId){
            rangeModule.push(item.moduleId);
        }
    })
    this.pageModuleList&&this.pageModuleList.forEach(pageObject=>{
        if(!routerId||pageObject.routerId==routerId){
            if(pageObject.pageModule){
                pageObject.pageModule.page.componentsMap.forEach(item=>{
                    //查找指定的key名称（formGroupKey）
                    var formGroupKey = item.props&&item.props.compositeAttr?item.props.compositeAttr.formGroupKey:"";
                    if(!_.includes(rangeModule,item.packageid)&&formGroupKey==groupKey&&formGroupKey!=''){
                        rangeModule.push(item.packageid)
                    }
                })
            }
        }
    });
    return rangeModule;
}
/**
 * 
 * @param {
 * moduleId:"窗口ID",
 * openUrl:"打开的url地址，当只有一个iframe的时候才有效，多个iframe时候请使用数组形式，[{name:'iframe的name',url:""}]",
 * success:层弹出后的成功回调方法,
 * yes:确定按钮回调方法,
 * cancel:关闭触发的回调,
 * end:层销毁后触发的回调
 * } option 
 */
function openDialog(option){
    this.callLayerHandle({
        //当前页面直接发送的
        type:"direct",
        oType:"open",
        option
    })
}
/**
 * 
 * @param {
 * moduleId:"窗口ID" or ["窗口ID1","窗口ID2"]
 * } option 
 */
function closeDialog(option){
    this.callLayerHandle({
        //当前页面直接发送的
        type:"direct",
        oType:"close",
        option
    })
}


/**
 * 执行组件的打开关闭公共方法
 * @param {
 *  type:"direct 或者 across",
 *  oType:"open 或者 close"
 *  option：发送消息的对象数据
 * } object 
 */
function callLayerHandle(object){
    if(object.oType=="open"){
        window.IdmBuiltin_OpenDialog({
            targetModule:[{moduleId:object.option.moduleId}],
            layerOption:object.option
        })
    }else if(object.oType=="close"){
        var targetModule = [];
        if(object.option.moduleId instanceof Array){
            object.option.moduleId.forEach(item=>{
                targetModule.push({moduleId:item})
            })
        }else{
            targetModule.push({moduleId:object.option.moduleId})
        }
        window.IdmBuiltin_CloseDialog({
            targetModule:targetModule,
            layerOption:object.option
        })
    }
    //如果object.type=="direct" 则需要往父级发送
    if(object.type=="direct"){
        //发起者的地址
        object.originUrl = location.href;
        //直连情况下还是要继续往上找一级，要执行深度拷贝，不然会影响后面的执行，导致下面哪个else也会执行
        this.findParentLayerHandle(_.cloneDeep(object))
    }
    //获取子级iframe了(如果是往上找的就不要再往下了)
    if(object.type!="parent"){
        if(window.frames.length>0){
            for (let index = 0; index < window.frames.length; index++) {
                const iframe = window.frames[index];
                if(iframe.IDM){
                    iframe.IDM.broadcast&&iframe.IDM.broadcast.bridgeLayer(_.cloneDeep(object));
                }
            }
        }
    }else{
        //继续往上找
        this.findParentLayerHandle(_.cloneDeep(object))
    }
}
/**
 * 桥接消息发送的方法
 * @param {*} object 
 */
function bridgeLayer(object){
    object.type = "across";
    //这里给组件传消息的时候把isAcross设置为true加上
    this.callLayerHandle(object)
}
/**
 * 向父级页面直接调用callLayerHandle消息函数
 * @param {*} object 
 */
function findParentLayerHandle(object){
    object.type = "parent";
    //判断是否有父级
    if(parent.location.href!=location.href){
        //代表着父级页面存在
        parent.IDM&&parent.IDM.broadcast.callLayerHandle(object)
    }
}


/**
 * 打开控制组件设置面板，返回面板ID，可以用这个进行关闭
 * @param {
 * url:"要展示的页面地址，如果为空则使用页面设置=>控制中心的默认地址",
 * param:{
 *  marketModuleId:"必填，市场组件的ID，组件内取this.moduleObject.comId即可",
 *  pageId:"必填，页面的ID，直接使用 window.IDM.broadcast.pageModule.id 即可获取",
 *  packageid:"必填，组件实例的ID，主要用于区别页面的同一个组件，直接使用 this.moduleObject.packageid 即可获取到"
 * },
 * title:"要显示的标题，如果为空则取页面属性设置的",
 * showTitle:Boolean类型，不传则使用设置的，如果传true和false则会直接控制,
 * width:"宽度	string | number	256，如果为空则取页面属性设置的",
 * height:"高度, 在 placement 为 top 或 bottom 时使用	string | number	256，如果为空则取页面属性设置的",
 * placement:"抽屉的方向	'top' | 'right' | 'bottom' | 'left' | 'center'	'right'，如果为空则取页面属性设置的",
 * showTop:默认为true，设置是否显示在最顶级页面中，这样做的目的是为了在跨页面的时候遮罩显示在最外面，能覆盖整个窗口
 * success:层弹出后的成功回调方法,
 * yes:确定按钮回调方法,
 * reset:重置后的回调,
 * other:关闭或其他按钮触发回调方法
 * } option 
 */
function openControlSetPanel(option){
    const controlSetPanelId = "ControlSetPanel_"+IDM.UUID();
    option["controlSetPanelId"] = controlSetPanelId;
    this.callControlSetPanelHandle({
        //当前页面直接发送的
        type:"direct",
        oType:"open",
        option
    })
    return controlSetPanelId;
}
/**
 * 
 * @param {
 * controlSetPanelId:"控制面板窗口ID"
 * } option 
 */
function closeControlSetPanel(option){
    this.callControlSetPanelHandle({
        //当前页面直接发送的
        type:"direct",
        oType:"close",
        option
    })
}


/**
 * 执行设置面板的打开关闭公共方法
 * @param {
 *  type:"direct",
 *  oType:"open 或者 close"
 *  option：发送消息的对象数据
 * } object 
 */
function callControlSetPanelHandle(object){
    if(object.oType=="close"){
        //调用关闭方法
        window.IdmBuiltin_CloseControlSetPanel({
            controlSetPanelOption:object.option
        })
        //如果object.type=="direct" 则需要往父级发送
        if(object.type=="direct"){
            //发起者的地址
            object.originUrl = location.href;
            //直连情况下还是要继续往上找一级，要执行深度拷贝，不然会影响后面的执行，导致下面哪个else也会执行
            this.findParentControlSetPanelHandle(_.cloneDeep(object))
        }
        //获取子级iframe了(如果是往上找的就不要再往下了)
        if(object.type!="parent"){
            if(window.frames.length>0){
                for (let index = 0; index < window.frames.length; index++) {
                    const iframe = window.frames[index];
                    if(iframe.IDM){
                        iframe.IDM.broadcast&&iframe.IDM.broadcast.bridgeControlSetPanel(_.cloneDeep(object));
                    }
                }
            }
        }else{
            //继续往上找
            this.findParentControlSetPanelHandle(_.cloneDeep(object))
        }
    }else{
        if(object.option.showTop===false){
            //不在顶端执行，在当前页面
            //调用打开设置中心
            window.IdmBuiltin_OpenControlSetPanel({
                controlSetPanelOption:object.option
            })
            return;
        }
        //继续往上找
        const isTopPage = this.findParentControlSetPanelHandle(_.cloneDeep(object));
        if(isTopPage){
            //调用打开设置中心
            window.IdmBuiltin_OpenControlSetPanel({
                controlSetPanelOption:object.option
            })
        }
    }
}
/**
 * 桥接消息发送的方法
 * @param {*} object 
 */
function bridgeControlSetPanel(object){
    object.type = "across";
    //这里给组件传消息的时候把isAcross设置为true加上
    this.callControlSetPanelHandle(object)
}
/**
 * 向父级页面直接调用callControlSetPanelHandle消息函数
 * @param {*} object 
 */
function findParentControlSetPanelHandle(object){
    object.type = "parent";
    //判断是否有父级
    if(parent.location.href!=location.href){
        //代表着父级页面存在
        parent.IDM&&parent.IDM.broadcast.callControlSetPanelHandle(object);
        if(parent.IDM){
            return false;
        }else{
            return true;
        }
    }else{
        return true;
    }
}

export default {
    pageModuleList,
    registerModule,
    unRegisterModule,
    send,
    bridgeSend,
    callModuleReceiveHandle,
    findParentModuleHandle,
    sendChildren,
    sendChildrenInner,
    pageModule:pageModule,
    pageModuleIsLoadComplete:pageModuleIsLoadComplete,
    waitReceiveMessage:waitReceiveMessage,
    waitChildrenReceiveMessage:waitChildrenReceiveMessage,
    pageLoadCompleteAfter:pageLoadCompleteAfter,
    pageModuleLoadCompleteBefore:pageModuleLoadCompleteBefore,
    getModuleContextValue:getModuleContextValue,
    getRangeModule:getRangeModule,
    openDialog,
    closeDialog,
    bridgeLayer,
    callLayerHandle,
    findParentLayerHandle,

    openControlSetPanel,
    closeControlSetPanel,
    callControlSetPanelHandle,
    bridgeControlSetPanel,
    findParentControlSetPanelHandle
}